// Snow Products — Blanco Premium JS v6

// — Formato de precio —
(function () {
  var re = /^€\s*([\d,.]+)(?:\s+EUR)?$/;
  function fix(el) {
    if (el.childElementCount === 0) {
      var t = el.textContent.trim(), m = t.match(re);
      if (m) el.textContent = m[1] + '€';
    }
  }
  function fixAll() { document.querySelectorAll('.money, .price-item').forEach(fix); }
  if (window.Shopify) window.Shopify.money_format = '{{amount_with_comma_separator}}€';
  document.addEventListener('DOMContentLoaded', fixAll);
  var debounce;
  new MutationObserver(function () { clearTimeout(debounce); debounce = setTimeout(fixAll, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', function () {

  var isProduct = window.location.pathname.indexOf('/products/') !== -1;

  // — Trust bar —
  if (isProduct) {
    var form = document.querySelector('.product-form, form[action="/cart/add"]');
    if (form) {
      var bar = document.createElement('div');
      bar.className = 'sp-trust-bar';
      bar.innerHTML = ['Envío gratis en pedidos +100€','Devolución gratuita en pedidos superiores a 100€','Pago 100% seguro','Expertos en nieve y moda']
        .map(function(t){return '<span class="sp-trust-item">'+t+'</span>';}).join('');
      form.parentNode.insertBefore(bar, form.nextSibling);
    }
  }

  // — Floating finder tab (Encuentra tu equipo) — all pages —
  (function(){
    var CSS=
      '#sp-finder{position:fixed;right:0;top:50%;transform:translateY(-50%);z-index:9980;display:flex;align-items:center;}'
      +'#sp-finder-tab{background:#111;color:#fff;border:none;cursor:pointer;padding:0;display:flex;align-items:center;border-radius:8px 0 0 8px;overflow:hidden;transition:width .25s ease;width:48px;height:56px;text-decoration:none;}'
      +'#sp-finder-tab:hover,#sp-finder-tab.expanded{width:200px;}'
      +'#sp-finder-icon{width:48px;height:56px;flex-shrink:0;display:flex;align-items:center;justify-content:center;}'
      +'#sp-finder-text{white-space:nowrap;overflow:hidden;font-size:.82rem;font-weight:700;letter-spacing:.01em;padding-right:14px;opacity:0;transition:opacity .2s .1s;}'
      +'#sp-finder-tab:hover #sp-finder-text,#sp-finder-tab.expanded #sp-finder-text{opacity:1;}';
    var s=document.createElement('style');s.textContent=CSS;document.head.appendChild(s);
    var w=document.createElement('div');w.id='sp-finder';
    w.innerHTML='<a id="sp-finder-tab" href="/pages/encuentra-tu-equipo" title="Encuentra tu equipo ideal">'
      +'<span id="sp-finder-icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/></svg></span>'
      +'<span id="sp-finder-text">¿Cuál es tu equipo?</span>'
      +'</a>';
    document.body.appendChild(w);
    var key='sp-finder-seen';
    if(!sessionStorage.getItem(key)){
      sessionStorage.setItem(key,'1');
      var tab=w.querySelector('#sp-finder-tab');
      setTimeout(function(){
        tab.classList.add('expanded');
        setTimeout(function(){tab.classList.remove('expanded');},2200);
      },1500);
    }
  })();

  // — "Retiro disponible" → "Recogida disponible" —
  function fixPickup() {
    document.querySelectorAll('pickup-availability, [class*="pickup"]').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/Retiro disponible/g, 'Recogida disponible')
        .replace(/Retiro no disponible/g, 'Recogida no disponible');
    });
  }
  fixPickup();
  setTimeout(fixPickup, 1500);

  // — Barra progreso envío —
  function updateShippingBar() {
    var cart = window.Shopify && window.Shopify.cart ? window.Shopify.cart : null;
    if (!cart) return;
    var total = (cart.total_price || 0) / 100, pct = Math.min(total / 100 * 100, 100);
    var fill = document.querySelector('.sp-shipping-fill'), msg = document.querySelector('.sp-shipping-msg');
    if (fill) fill.style.width = pct + '%';
    if (msg) msg.textContent = total >= 100 ? '¡Envío gratis conseguido!' : 'Te faltan ' + (100 - total).toFixed(2) + '€ para envío gratis';
  }
  var cartEl = document.querySelector('cart-drawer, .cart__items, [id="cart"]');
  if (cartEl) {
    var prog = document.createElement('div');
    prog.innerHTML = '<div class="sp-shipping-progress"><div class="sp-shipping-fill"></div></div><p class="sp-shipping-msg"></p>';
    cartEl.prepend(prog);
    updateShippingBar();
    document.addEventListener('cart:updated', updateShippingBar);
  }

  // — Sticky ATC móvil —
  if (isProduct && window.innerWidth <= 749) {
    var atc = document.querySelector('.product-form__submit');
    if (atc) {
      var sticky = document.createElement('div');
      sticky.className = 'sp-sticky-atc';
      var btn = document.createElement('button');
      btn.textContent = atc.textContent.trim() || 'Agregar al carrito';
      btn.onclick = function () { atc.click(); };
      sticky.appendChild(btn);
      document.body.appendChild(sticky);
    }
  }

  // — Blog filter activo —
  document.querySelectorAll('.sp-blog-filter a').forEach(function (a) {
    if (window.location.pathname.indexOf(a.getAttribute('href')) !== -1) a.classList.add('active');
  });

  // — Cargar comparador en páginas de producto —
  if (isProduct && !document.getElementById('cmp-overlay')) {
    var existing = document.querySelector('script[src*="product-compare.js"]');
    if (!existing) {
      var ref = document.querySelector('script[src*="/assets/"]');
      if (ref) {
        var base = ref.src.replace(/\/assets\/.*$/, '/assets/');
        var cmpScript = document.createElement('script');
        cmpScript.src = base + 'product-compare.js';
        cmpScript.defer = true;
        document.head.appendChild(cmpScript);
      }
    }
  }

});

// — In-stock sizes badge + ordenación preventa —
(function() {
  'use strict';
  function renderBadge(card, sizes) {
    if (!sizes || sizes.length === 0) return;
    var preorder = card.querySelector('.card__badge .badge--preorder');
    if (!preorder) return;
    var inner = card.querySelector('.card__inner');
    if (!inner) return;
    if (inner.querySelector('.card__instock-badge')) return;
    var div = document.createElement('div');
    div.className = 'card__instock-badge';
    var header = document.createElement('div');
    header.className = 'card__instock-header';
    header.textContent = 'EN STOCK';
    div.appendChild(header);
    var chipsDiv = document.createElement('div');
    chipsDiv.className = 'card__instock-chips';
    sizes.forEach(function(s) {
      var span = document.createElement('span');
      span.className = 'card__instock-chip';
      span.textContent = s;
      chipsDiv.appendChild(span);
    });
    div.appendChild(chipsDiv);
    inner.appendChild(div);
  }
  function getHandle(el) {
    var a = el.querySelector('a.full-unstyled-link');
    if (!a) return null;
    var match = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return match ? match[1] : null;
  }
  function sortPreventaGrid(data) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    Array.prototype.forEach.call(grid.children, function(item) {
      var handle = getHandle(item);
      var isPreorder = item.querySelector('.badge--preorder');
      if (!isPreorder || !handle) return;
      var productData = data[handle] || {};
      var hasStock = Object.keys(productData).some(function(k) { return productData[k] && productData[k].length > 0; });
      if (hasStock) item.style.order = '-1';
    });
  }
  function init() {
    var data = window.spInstockData || {};
    sortPreventaGrid(data);
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      var preorder = card.querySelector('.card__badge .badge--preorder');
      if (!preorder) return;
      var handle = getHandle(card);
      if (!handle) return;
      var productData = data[handle];
      if (!productData) return;
      var cardColor = card.getAttribute('data-color');
      var sizes;
      if (cardColor && productData[cardColor]) {
        sizes = productData[cardColor];
      } else if (!cardColor) {
        // Single-color product: flatten all sizes
        sizes = [];
        var seen = {};
        Object.keys(productData).forEach(function(k) {
          (productData[k] || []).forEach(function(s) {
            if (!seen[s]) { seen[s] = 1; sizes.push(s); }
          });
        });
      }
      renderBadge(card, sizes);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

// — Disponibles primero en colecciones —
(function() {
  var isCollection = document.body && document.body.classList.contains('template-collection');
  if (!isCollection) {
    // Also check via main[data-template]
    var main = document.querySelector('main[data-template]');
    isCollection = main && main.dataset.template === 'collection';
  }
  if (!isCollection) return;

  function sortAvailableFirst(grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    items.sort(function(a, b) {
      var aCard = a.querySelector('[data-available]');
      var bCard = b.querySelector('[data-available]');
      var aAvail = aCard && aCard.dataset.available === 'false' ? 0 : 1;
      var bAvail = bCard && bCard.dataset.available === 'false' ? 0 : 1;
      return bAvail - aAvail;
    });
    items.forEach(function(item) { grid.appendChild(item); });
  }

  function setup() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    sortAvailableFirst(grid);
    new MutationObserver(function() { sortAvailableFirst(grid); }).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
